import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API from '../utils/api';
import './Login.css';

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) return setError('Password tidak cocok');
    setLoading(true);
    try {
      await API.post('/auth/register', { name: form.name, email: form.email, password: form.password });
      alert('Registrasi berhasil! Silakan login.');
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.message || 'Registrasi gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">📝</div>
          <h1>Daftar Akun Peserta</h1>
          <p>Buat akun untuk mengikuti ujian</p>
        </div>
        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="alert-error">{error}</div>}
          <div className="form-group">
            <label>Nama Lengkap</label>
            <input type="text" name="name" value={form.name} onChange={handleChange}
              placeholder="Nama lengkap Anda" required />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" name="email" value={form.email} onChange={handleChange}
              placeholder="email@contoh.com" required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" name="password" value={form.password} onChange={handleChange}
              placeholder="Min. 6 karakter" required minLength={6} />
          </div>
          <div className="form-group">
            <label>Konfirmasi Password</label>
            <input type="password" name="confirm" value={form.confirm} onChange={handleChange}
              placeholder="Ulangi password" required />
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Mendaftar...' : 'Daftar Sekarang'}
          </button>
        </form>
        <p className="auth-footer">
          Sudah punya akun? <Link to="/login">Login di sini</Link>
        </p>
      </div>
    </div>
  );
}
